module.exports = __webpack_public_path__ + "static/media/info-banner-waifu.0b35715e.svg";